import { render, staticRenderFns } from "./DevinirNonCompliantAccountView.vue?vue&type=template&id=4fc80afa&scoped=true"
import script from "./DevinirNonCompliantAccountView.vue?vue&type=script&lang=ts"
export * from "./DevinirNonCompliantAccountView.vue?vue&type=script&lang=ts"
import style0 from "./DevinirNonCompliantAccountView.vue?vue&type=style&index=0&id=4fc80afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc80afa",
  null
  
)

export default component.exports